// Campus photo for /colleges/university-of-north-carolina-at-chapel-hill: CC BY-SA 4.0, by Jack a lanier, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUNC_Chapel_Hill_-_Old_Well_with_flowers.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-north-carolina-at-chapel-hill/; credited under the photo.
const photo = {
    "slug": "university-of-north-carolina-at-chapel-hill",
    "alt": "The Old Well among flower beds at the University of North Carolina at Chapel Hill, with Old West behind it",
    "src": "/colleges/university-of-north-carolina-at-chapel-hill/campus-1600.webp",
    "srcSmall": "/colleges/university-of-north-carolina-at-chapel-hill/campus-800.webp",
    "srcMid": "/colleges/university-of-north-carolina-at-chapel-hill/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-north-carolina-at-chapel-hill/og.jpg",
    "title": "UNC Chapel Hill - Old Well with flowers",
    "author": "Jack a lanier",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUNC_Chapel_Hill_-_Old_Well_with_flowers.jpg",
    "read": "2026-10-01"
};

export default photo;
